// src/plugins/loading.js
import { reactive } from 'vue'

export let globalLoadingState = reactive({
  visible: false
})

let loadingController = {
  show() {
    globalLoadingState.visible = true
  },
  hide() {

    setTimeout(() => {
      globalLoadingState.visible = false  
    }, 800);
    
  }
}

export default {
  install(app) {
    // Disponível via this.$loading e também globalmente como $loading
    app.config.globalProperties.$loading = loadingController
    window.$loading = loadingController
  }
}
